import React, { useState } from "react";
import "./confirmation-form.css";

const ConfirmationForm = ({setTermsAccepted, sponsorName, email}) => {
  const [acceptCntr, setAcceptCntr] = useState(1);
  const checkboxHandler = (e) => {
    if (e.target.checked) {
      setAcceptCntr((prevVal) => prevVal + 1);
    } else {
      setAcceptCntr((prevVal) => prevVal - 1);
    }
    if (acceptCntr === 6) {
      setTermsAccepted(true);
    } else {
      setTermsAccepted(false);
    }
  }
  return (
    <>
    <h2 className="fw-bold">CONFIRMATION</h2>
    <h6 className="my-3">Please confirm the information below </h6>
    <div className="confirmation-container">
      <div className="confirmation-header">
        <i className="fa fa-check-circle confirmation-icon"></i>
        <span>I confirm that the information entered below is correct and accurate.</span>
      </div>
      <ul className="confirmation-list">
        <li>
          <input type="checkbox" id="enrollment"
          onChange={checkboxHandler}
          className="terms-check" required />
          <label htmlFor="enrollment">
            I have been enrolled by <b>{sponsorName}</b>.
          </label>
        </li>
        <li>
          <input 
          onChange={checkboxHandler}
          type="checkbox" id="donation" required />
          <label htmlFor="donation">
            I wish to gift/donate £20 (starting at level 1) up to level 12, as my own decision with no expectation of financial returns.
          </label>
        </li>
        <li>
          <input
          onChange={checkboxHandler}
          type="checkbox" id="agreement" required />
          <label htmlFor="agreement">
            I agree that if I do not honour any gifts/donations for subsequent levels, I may risk having any or all privileges associated with WJCW CF and WJCW revoked.
          </label>
        </li>
        <li>
          <input
          onChange={checkboxHandler}
          type="checkbox" id="emailConfirmation" required />
          <label htmlFor="emailConfirmation">
            I can confirm <b>{email}</b> that the following email address is valid and belongs to me:
          </label>
        </li>
        <li>
          <input
          onChange={checkboxHandler}
          type="checkbox" id="licenseFee" required />
          <label htmlFor="licenseFee">
            I understand that until I pay the annual license fee of £12 for WJCW CF, I will not have access to the member area.
          </label>
        </li>
        <li>
          <input
          onChange={checkboxHandler}
          type="checkbox" id="rulesAcknowledgment" required />
          <label htmlFor="rulesAcknowledgment">
            I understand and acknowledge that I must follow the rules set by WJCW and faithfully follow the system which is beneficial for myself and for the community around the globe in order to qualify to become a shareholder of WJCW.
          </label>
        </li>
      </ul>
    </div>
    </>
  );
};

export default ConfirmationForm;
